import { useConfig } from '@providers/ConfigRedirectProvider';
import packageJson from '../../../package.json';

export function VersionBadge() {
  const config = useConfig()
  const configParams = config.params

  if (configParams?.ver !== 'show') return null

  return (
    <div
      style={{
        position: 'fixed',
        top: 2,
        left: 4,
        color: 'red',
        fontSize: 8,
        zIndex: 1000,
      }}
    >
      {packageJson.version}
    </div>
  )
}
